import { Component, OnInit } from '@angular/core';
import { GlobalServicesService } from 'src/app/services/global-services.service';
import { JobServicesService } from 'src/app/services/job-services.service';
import { ActivatedRoute } from '@angular/router';
import { SharedServicesService } from 'src/app/services/shared-services.service';

@Component({
    selector: 'app-access-management',
    templateUrl: './access-management.component.html',
    styleUrls: ['./access-management.component.css'],
    standalone: false
})
export class AccessManagementComponent implements OnInit {
  
  isLoadingRoles: boolean = false;
  isLoadingMembers: boolean = false;
  isLoading: boolean = false;
  isInEvent: boolean = false;
  jobId: string = '';
  eventId: string = '';
  eventJobType: string = '';

  userRole: string = '';
  userPrivileges: Set<string> = new Set();
  formData: any = null;
  assignedRoles: any[] = [];

  currentView: string = 'empty';
  selectedRole: any = null;
  showRoleModal: boolean = false;
  showAddMembersModal: boolean = false;
  searchTerm: string = '';
  statusFilter: string = 'all';
  departmentFilter: string = 'all';
  selectedMembers: string[] = [];
  selectAll: boolean = false;
  cameFromRoleSelection: boolean = false;

  availableRoles: any[] = [];
  availableTeamMembers: any[] = [];
  allUsers: any[] = []; 
  showDeleteConfirmModal: boolean = false;
  roleToDelete: any = null;
  isDeleting: boolean = false;
  showDeleteMemberModal: boolean = false;
  memberToDelete: any = null;
  isDeletingMember: boolean = false;
  constructor(private jobService: JobServicesService, private globalService: GlobalServicesService,private activatedRoute: ActivatedRoute,) { }

  ngOnInit(): void {
    this.activatedRoute.paramMap.subscribe(params => {
      this.eventId = params.get('eventId') || '';
      const sharedService = this.globalService.getSharedService();  
      const existingEventDetails = sharedService.getEventDetails(this.eventId);

      if (!existingEventDetails?.manage_access) {
        this.checkExistingRoles();
        return;
      }
      this.handleExistingEventDetails(existingEventDetails);
      if (existingEventDetails) {
        this.handleExistingEventDetails(existingEventDetails);
      } else {
        this.checkExistingRoles();
      }
  
      this.userRole = this.globalService.privilegeRoles;
      this.globalService.privilegeDetailsSubject.subscribe((privileges) => {
        this.userPrivileges = privileges;
      });    
    });
  }
  handleExistingEventDetails(eventDetails: any): void {
    const manageAccess = eventDetails?.manage_access;
  
    if (!manageAccess || manageAccess.length === 0) {
      this.currentView = 'empty';
      this.assignedRoles = [];
      return;
    }
  
    this.formData = manageAccess;
  
    this.assignedRoles = manageAccess.map((role: any) => ({
      id: role.role_id,
      name: role.role_name,
      description: `Manage ${role.role_name?.toLowerCase()} responsibilities`,
      users: role.users || []
    }));
  
    if (this.assignedRoles.length > 0) {
      this.currentView = 'role-detail';
      this.selectedRole = { ...this.assignedRoles[0] };
  
      this.availableTeamMembers = this.selectedRole.users.map((user: any) => ({
        id: user.id,
        user_id: user.id,
        name: `${user.first_name} ${user.last_name}`,
        email: user.email,
        department: this.selectedRole.name,
        status: 'active',
        initials: `${user.first_name[0]}${user.last_name[0]}`.toUpperCase()
      }));
    }
  }
    
  getAvailableRoles(): any[] {
    if (!this.availableRoles || !this.assignedRoles) return [];
    const assignedRoleIds = this.assignedRoles.map(role => role.id);
    return this.availableRoles.filter(role => !assignedRoleIds.includes(role.id));
  }
  
  getAvailableMembersForRole(): any[] {
    if (!this.selectedRole || !this.availableTeamMembers) return [];    
    const assignedUserIds = this.selectedRole.users ? this.selectedRole.users.map((user: any) => user.id) : [];    
    return this.availableTeamMembers.filter(member => !assignedUserIds.includes(member.user_id));
  }
  loadRolesData(): void {
    this.isLoadingRoles = true;
    this.availableRoles = []; 
    this.jobService.getRoleAndPermissionFastApi().subscribe({
      next: (response) => {
        const rolesData = response.body || [];        
        this.availableRoles = rolesData
          .map((role: any) => ({
            id: role.id,
            name: role.name,
            description: role.description
          }));
        
        this.isLoadingRoles = false;
      },
      error: (error) => {
        console.error('Error loading roles:', error);
        this.isLoading = false;
      }
    });
  }
  
  loadUsersForSelectedRole(): void {
    if (!this.selectedRole?.id) return;
    this.isLoadingMembers=true;
    this.availableTeamMembers = [];
    this.jobService.getUsersFastApi(1, 100).subscribe({
      next: (response) => {
        const usersData = response.body || {};
        this.allUsers = usersData.items || [];        
        const usersWithSelectedRole = this.allUsers.filter((user: any) => 
          user.role && user.role.id === this.selectedRole.id
        );
        this.availableTeamMembers = usersWithSelectedRole.map((user: any) => ({
          id: user.id,
          user_id: user.id,
          role_id: this.selectedRole.id,
          name: `${user.first_name} ${user.last_name}`,
          email: user.email,
          department: user.role.name,
          status: 'active',
          initials: `${user.first_name[0]}${user.last_name[0]}`.toUpperCase(),
          mobile_number: user.mobile_number,
          created_at: user.created_at
        }));
        
        this.isLoadingMembers = false;
      },
      error: (error) => {
        console.error('Error loading users:', error);
        this.isLoadingMembers = false;
        this.availableTeamMembers = [];
      }
    });
  }
  checkExistingRoles(): void {
    this.jobService.getSpecificEventFastApi(this.eventId).subscribe({
      next: (response) => {
        const data = response.body;
  
        if (!data || !data.manage_access || data.manage_access.length === 0) {
          this.currentView = 'empty';
          this.assignedRoles = [];
          return;
        }
  
        this.formData = data.manage_access;
  
        this.assignedRoles = data.manage_access.map((role: any) => ({
          id: role.role_id,
          name: role.role_name,
          description: `Manage ${role.role_name?.toLowerCase()} responsibilities`,
          users: role.users || []
        }));
  
        if (this.assignedRoles.length > 0) {
          this.currentView = 'role-detail';          
          if (!this.selectedRole) {
            this.selectedRole = { ...this.assignedRoles[0] };
          } else {
            const updatedSelectedRole = this.assignedRoles.find(role => role.id === this.selectedRole.id);
            if (updatedSelectedRole) {
              this.selectedRole = { ...updatedSelectedRole };
            }
          }  
          if (this.selectedRole) {
            this.availableTeamMembers = this.selectedRole.users.map((user: any) => ({
              id: user.id,
              user_id: user.id,
              name: `${user.first_name} ${user.last_name}`,
              email: user.email,
              department: this.selectedRole.name,
              status: 'active',
              initials: `${user.first_name[0]}${user.last_name[0]}`.toUpperCase()
            }));
          }
        } else {
          this.currentView = 'empty';
        }
      },
      error: () => {
        this.currentView = 'empty';
        this.assignedRoles = [];
      }
    });
  }

  openRoleSelection() {
    this.showRoleModal = true;
    this.selectedRole = null;
    this.loadRolesData();
  }

  selectRole(role: any) {
    this.selectedRole = role;
  }

  addSelectedRole(): void {
    if (this.selectedRole) {
      this.showRoleModal = false;
      this.loadUsersForSelectedRole();
      this.showAddMembersModal = true;
      this.selectedMembers = [];
      this.cameFromRoleSelection = true;
      this.loadUsersForSelectedRole();
    }
  }
  loadMembersForRole(): void {
    if (!this.selectedRole) return;    
    this.loadUsersForSelectedRole();
  }
  openAddMembers(role?: any): void {
    if (role) {
      this.selectedRole = { ...role };
    }
    if (this.selectedRole && this.selectedRole.id) {
      this.loadUsersForSelectedRole();
    }
    this.showAddMembersModal = true;
    this.selectedMembers = [];
    this.selectAll = false;
    this.searchTerm = '';
    this.cameFromRoleSelection = false;
    if (this.selectedRole && this.selectedRole.id) {
      this.loadUsersForSelectedRole();
    }
  }
  

  closeModal() {
    this.showRoleModal = false;
    this.showAddMembersModal = false;    
    this.isLoadingRoles = false;
    this.isLoadingMembers = false;    
    if (!this.showRoleModal) {
      this.availableRoles = [];
    }
    if (!this.showAddMembersModal) {
      this.availableTeamMembers = [];
    }
  }

  goBack(): void {
    if (this.showAddMembersModal) {
      this.showAddMembersModal = false;
      this.showRoleModal = true;
      this.selectedRole = null; 
      this.isLoadingMembers = false;
      this.availableTeamMembers = [];
    } else {
      this.currentView = 'empty';
      this.selectedRole = null;
    }
  }

  toggleMemberSelection(memberId: string, checked: boolean) {
    if (checked) {
      this.selectedMembers.push(memberId);
    } else {
      this.selectedMembers = this.selectedMembers.filter(id => id !== memberId);
      this.selectAll = false;
    }
  }
  toggleMemberSelectionFromEvent(memberId: string, event: Event): void {
    const input = event.target as HTMLInputElement;
    if (input) {
      this.toggleMemberSelection(memberId, input.checked);
    }
  }
  toggleRoleSelection(role: any, event: Event): void {
    event.stopPropagation();
    if (this.selectedRole?.id === role.id) {
      this.selectedRole = null;
    } else {
      this.selectRole(role);
    }
  }
  
  toggleSelectAll(checked: boolean) {
    this.selectAll = checked;
    if (checked) {
      this.selectedMembers = this.getFilteredMembers().map(member => member.id);
    } else {
      this.selectedMembers = [];
    }
  }

  getFilteredMembers() {
    const availableMembers = this.getAvailableMembersForRole();
    if (!availableMembers || availableMembers.length === 0) return [];
    return availableMembers.filter(member => {
      const matchesSearch = member.name.toLowerCase().includes(this.searchTerm.toLowerCase()) ||
                           member.email.toLowerCase().includes(this.searchTerm.toLowerCase());
      const matchesStatus = this.statusFilter === 'all' || member.status === this.statusFilter;
      const matchesDepartment = this.departmentFilter === 'all' || member.department === this.departmentFilter;
      
      return matchesSearch && matchesStatus && matchesDepartment;
    });
  }

  addSelectedMembers(): void {
    if (!this.selectedRole || this.selectedMembers.length === 0) return;
      
    const newlySelectedUserIds = this.getFilteredMembers()
      .filter(member => this.selectedMembers.includes(member.id))
      .map(member => member.user_id);  
      
    const allExistingUserIds: number[] = [];
    
    this.assignedRoles.forEach(role => {
      if (role.id === this.selectedRole.id) {
        const existingUserIds = role.users.map((user: any) => user.id);
        const mergedUserIds = Array.from(new Set([...existingUserIds, ...newlySelectedUserIds]));
        allExistingUserIds.push(...mergedUserIds);
      } else {
        const existingUserIds = role.users.map((user: any) => user.id);
        allExistingUserIds.push(...existingUserIds);
      }
    });  
    
    const isNewRole = !this.assignedRoles.some(role => role.id === this.selectedRole.id);
    if (isNewRole) {
      allExistingUserIds.push(...newlySelectedUserIds);
    }  
    
    const uniqueUserIds = Array.from(new Set(allExistingUserIds));
    
    const payload = [
      {
        user_id: uniqueUserIds
      }
    ];
  
    this.isLoading = true;
  
    this.jobService.addMembersToRole(this.eventId, this.selectedRole.id, payload).subscribe({
      next: (response) => {
        this.isLoading = false;
        this.showAddMembersModal = false;
        this.currentView = 'role-detail';        
        this.checkExistingRoles();        
        this.selectedMembers = [];
        this.selectAll = false;
        this.searchTerm = '';
        this.availableTeamMembers=[];
      },
      error: (error) => {
        console.error('Error adding members:', error);
        this.isLoading = false;
      }
    });
  }
  confirmDeleteMember(member: any): void {
    this.memberToDelete = member;
    this.showDeleteMemberModal = true;
  }

  closeDeleteMemberModal(): void {
    this.showDeleteMemberModal = false;
    this.memberToDelete = null;
    this.isDeletingMember = false;
  }
  deleteMember(): void {
    if (!this.memberToDelete || !this.selectedRole) return;
    this.isDeletingMember = true;
    const allExistingUserIds: number[] = [];
    
    this.assignedRoles.forEach(role => {
      if (role.id === this.selectedRole.id) {
        const existingUserIds = role.users
          .filter((user: any) => user.id !== this.memberToDelete.id)
          .map((user: any) => user.id);
        allExistingUserIds.push(...existingUserIds);
      } else {
        const existingUserIds = role.users.map((user: any) => user.id);
        allExistingUserIds.push(...existingUserIds);
      }
    });
    const uniqueUserIds = Array.from(new Set(allExistingUserIds));
    const payload = [
      {
        user_id: uniqueUserIds
      }
    ];
    this.jobService.addMembersToRole(this.eventId, this.selectedRole.id, payload).subscribe({
      next: (response) => {
        this.selectedRole.users = this.selectedRole.users.filter(
          (user: any) => user.id !== this.memberToDelete.id
        );        
        this.availableTeamMembers = this.availableTeamMembers.filter(
          member => member.id !== this.memberToDelete.id
        );        
        const roleIndex = this.assignedRoles.findIndex(role => role.id === this.selectedRole.id);
        if (roleIndex !== -1) {
          this.assignedRoles[roleIndex].users = this.selectedRole.users;
        }        
        this.closeDeleteMemberModal();        
        this.checkExistingRoles();
      },
      error: (error) => {
        console.error('Error deleting member:', error);
        this.isDeletingMember = false;
      }
    });
  }
  confirmDeleteRole(role: any): void {
    this.roleToDelete = role;
    this.showDeleteConfirmModal = true;
  }
  closeDeleteConfirmModal(): void {
    this.showDeleteConfirmModal = false;
    this.roleToDelete = null;
    this.isDeleting = false;
  }
  deleteRole(): void {
    if (!this.roleToDelete || !this.eventId) return;

    this.isDeleting = true;

    this.jobService.deleteEventRole(this.eventId, this.roleToDelete.id).subscribe({
      next: (response) => {
        this.assignedRoles = this.assignedRoles.filter(role => role.id !== this.roleToDelete.id);        
        if (this.selectedRole && this.selectedRole.id === this.roleToDelete.id) {
          if (this.assignedRoles.length > 0) {
            this.selectedRole = { ...this.assignedRoles[0] };
            this.updateAvailableTeamMembers();
          } else {
            this.currentView = 'empty';
            this.selectedRole = null;
          }
        }        
        this.closeDeleteConfirmModal();        
        this.checkExistingRoles();
      },
      error: (error) => {
        console.error('Error deleting role:', error);        
        this.isDeleting = false;
      }
    });
  }
  private updateAvailableTeamMembers(): void {
    if (this.selectedRole && this.selectedRole.users) {
      this.availableTeamMembers = this.selectedRole.users.map((user: any) => ({
        id: user.id,
        user_id: user.id,
        name: `${user.first_name} ${user.last_name}`,
        email: user.email,
        department: this.selectedRole.name,
        status: 'active',
        initials: `${user.first_name[0]}${user.last_name[0]}`.toUpperCase()
      }));
    }
  }
  selectRoleFromList(role: any): void {
    this.selectedRole = { ...role };
    this.updateAvailableTeamMembers();
  }
}